module.exports = __webpack_public_path__ + "img/banner-1.7acbccf5.jpg";